import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  heading: {
    lineHeight: "24px",
    letterSpacing: "0",
    fontSize: "18px",
    fontWeight: "600",
    fontStyle: "normal",
    marginBottom: "16px",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "2rem",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  leftContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    width: "65%",
    height: "fit-content",
    borderRadius: "6px",
    padding: "20px 33px 20px 16px",
    border: "1px solid rgb(207, 211, 213)",
    marginBottom: "12px",
    position: "relative",
    backgroundColor: "white",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  planText: {
    display: "flex",
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    // padding: "20px",
    borderRadius: "4px",
    fontSize: "14px",
    lineHeight: "22px",
  },
  rightContainerHead: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "22px",
    margin: "16px 0",
  },
  summaryHeadText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    color: "#272525",
  },
  planName: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
  },
  agentsText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
  },
  savingAmountText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "Green",
  },
  billedTexts: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "16px",
    color: "#272525",
  },
  submitBtnStyle: {
    backgroundColor: "#4d1277",
    color: "white",
    transitionDuration: ".2s",
    transitionProperty: "border,color,background-color",
    transitionTimingFunction: "cubic-bezier(.64,0,.35,1)",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
    },
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
    textTransform: "capitalize",
    borderRadius: "6px",
  },
  msgText: {
    marginTop: "16px",
    color: "#999",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
  },
}));

export default useStyles;
